var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"placement":"top","content":"回到顶部"}},[_c('back-to-top',{attrs:{"visibility-height":300,"back-position":0,"transition-name":"fade"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }